import React from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { CarouselHeader } from './header';
import { TileCarouselSectionContainer, TilesList } from './styled';
import { TileElement } from './tile-element';
import { ITrendingProps } from './types';

const CarouselSection: React.FC<ITrendingProps> = ({ item: tilesList }) => {
  const tiles = tilesList.tiles;
  const carouselHeader = tilesList.header?.locale;
  if (!tiles || tiles.length === 0) {
    return null;
  }

  const tilesComponent = tiles.map(tile => {
    if (!tile) {
      return null;
    }
    const title = tile.marketingBasicTileTitle?.locale || '';
    const description = tile.marketingBasicTileDescription?.localeRaw || '';
    return (
      <TileElement
        url={tile.link?.locale || ''}
        key={tile._id}
        id={tile._id}
        image={tile.marketingBasicTileImage?.locale?.app}
        imageDescription={tile.marketingBasicTileImage?.locale?.imageDescription || ''}
        title={title}
        description={description}
      />
    );
  });
  return (
    <TileCarouselSectionContainer data-testid="carousel-container">
      {!!carouselHeader && <CarouselHeader>{carouselHeader}</CarouselHeader>}
      <TilesList>
        <ResponsiveCarousel centerCards bgColor="transparent">
          {tilesComponent}
        </ResponsiveCarousel>
      </TilesList>
    </TileCarouselSectionContainer>
  );
};

export default CarouselSection;
